import React from 'react'
import { Marker } from 'react-google-maps'
import helpers from '../helpers'

const { MarkerClusterer } = require('react-google-maps/lib/components/addons/MarkerClusterer')

export default ({ clusterMarkers }) => (
  <MarkerClusterer
    key="clusteringLayer"
    averageCenter
    enableRetinaIcons
    gridSize={120}
    minimumClusterSize={1}
    styles={[
      {
        textColor: 'white',
        url: helpers.icons.cluster1,
        textSize: 14,
        width: 53,
        height: 53,
      },
      {
        textColor: 'white',
        url: helpers.icons.cluster2,
        textSize: 14,
        width: 56,
        height: 56,
      },
      {
        textColor: 'white',
        url: helpers.icons.cluster3,
        textSize: 14,
        width: 66,
        height: 66,
      },
      {
        textColor: 'white',
        url: helpers.icons.cluster4,
        textSize: 14,
        width: 78,
        height: 78,
      },
      {
        textColor: 'white',
        url: helpers.icons.cluster5,
        textSize: 14,
        width: 90,
        height: 90,
      },
    ]}
  >
    {
      clusterMarkers.map(marker => (
        <Marker
          key={marker.orderKey}
          position={{ lat: marker.latitude, lng: marker.longitude }}
        />
      ))
    }
  </MarkerClusterer>
)




// WEBPACK FOOTER //
// ./src/containers/mapView/components/Cluster.js